// Create Regularusers Group
export const CREATE_REGULARUSERS_GROUP_REQUEST = 'CREATE_REGULARUSERS_GROUP_REQUEST';
export const CREATE_REGULARUSERS_GROUP_DONE = 'CREATE_REGULARUSERS_GROUP_DONE';
export const CREATE_REGULARUSERS_GROUP_FAILED = 'CREATE_REGULARUSERS_GROUP_FAILED';